module.exports = __webpack_public_path__ + "static/img/1.79c8632.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/1.png
// module id = cCcL
// module chunks = 0